import { IState } from '../../store';
import { isAbUseExperimentsActive } from '../abUseExperiments';

export const NEWBUILDING_BUILDER_CALL_REASONS = 'newbuilding_builder_call_reasons';

/**
 * TODO: Удалить файл после раскатки эксперимента в CD-164236
 */
export const selectBuilderCallReasonsExperimentActive = (state: IState) => {
  const { abUseExperiments } = state;

  return isAbUseExperimentsActive(abUseExperiments, NEWBUILDING_BUILDER_CALL_REASONS, 'enabled');
};
